<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-bind:showNavbar="p_showNavbar"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
    </nav-bread>
    <div class="container">
      <el-container>
        <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 我的优惠券</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:10px 0 0 20px;">
          <el-header class="mhide">我的优惠券</el-header>
          <!-- 滚动文字 -->
          <div class="advert-top" v-if="expiryount">
            <marquee behavior=scroll>温馨提示：您有{{expiryount}}张优惠券将在三天内过期，尽快使用哦!</marquee>
          </div>
          <div class="tab">
            <ul>
              <li :class='isValidity === 1 ? "isActive" : ""'>
                <a @click="isValidity = 1">可用券<span class="num">（{{totalCount}}）</span></a>
              </li>
              <li :class='isValidity === 0 ? "isActive" : ""'>
                <a @click="isValidity = 0">失效券<span class="num">（{{totalCountInvalid}}）</span></a>
              </li>
            </ul>
            <div class="regulation">
              <a @click="rulesDetailHandle()">优惠券使用规则>></a>
            </div>
          </div>
          <template v-if="isValidity === 1">
            <!-- 可用券 -->
            <div class="result-empty" v-if="mycouponsList && !mycouponsList.length">
              <img src="../../assets/mycoupons_empty.png">
              <p>暂无优惠券</p>
            </div>
            <div class='list' v-else>
              <div class='coupon' v-for='(item,index) in mycouponsList' :key='index'>
                <div class='coupon_left'>
                  <div class='tip' v-if='item.rules === "{}"'>
                    <el-image :src='jbImg.green'></el-image>
                    <span class='txt'>通</span>
                  </div>
                  <div :class='item.rules === "{}" ? "price" : "price1"' v-if='item.couponType === 0'>
                    <span class='txt1'>￥</span>
                    <span class='txt2' v-if='numberLength(item.value) <= 3'>{{item.value}}</span>
                    <span class='txt2' v-if='numberLength(item.value) > 3'>{{item.value}}</span>
                    <a class="transfer" @click="toTransfer(item)">转赠</a>
                  </div>
                  <div class='price_discount' v-if='item.couponType === 1'>
                    <span class='txt1'>{{discountCoupon(item.value,10)}}</span>
                    <span class='txt2'>折</span>
                    <a class="transfer" @click="toTransfer(item)">转赠</a>
                  </div>
                  <div class='detail'>
                    <div class='detail_title'>【{{item.providerName}}】{{item.title}}</div>
                    <div class='detail_desc'>
                      <span class='txt3' v-if='item.amount === 0'>无门槛</span>
                      <span class='txt3' v-else>消费满{{item.amount}}可用</span>
                      <div v-if='item.isShowBeginDate'>
                        <span class='txt4'>有效期从:{{getCurrentTime(item.rangeBeginTime)}} 至:{{getCurrentTime(item.rangeEndTime)}}</span>
                      </div>
                      <div v-else>
                        <span class='txt4'>有效期至:{{getCurrentTime(item.rangeEndTime)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='coupon_right'>
                  <div class='coupon_right_btn' @click="doUse(item)">- 立即使用 -</div>
                </div>
              </div>
            </div>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="limit"
              layout="prev, pager, next, jumper"
              :total="totalCount"
              v-if="mycouponsList.length"
              style="text-align:center">
            </el-pagination>
          </template>
          <template v-else>
            <!-- 失效券 -->
            <div class="result-empty" v-if="invalidcouponsList && !invalidcouponsList.length">
              <img src="../../assets/mycoupons_empty.png">
              <p>暂无优惠券</p>
            </div>
            <div class='list' v-else>
              <div class='coupon_grey'  v-for='(item,index) in invalidcouponsList' :key='index'>
                <div class='coupon_left'>
                  <div class='tip' v-if='item.rules === "{}"'>
                    <el-image :src='jbImg.grey'></el-image>
                    <span class='txt'>通</span>
                  </div>
                  <div :class='item.rules === "{}" ? "price" : "price1"' v-if='item.couponType === 0'>
                    <span class='txt1'>￥</span>
                    <span class='txt2' v-if='numberLength(item.value) <= 3'>{{item.value}}</span>
                    <span class='txt2' v-if='numberLength(item.value) > 3'>{{item.value}}</span>
                  </div>
                  <div class='price_discount' v-if='item.couponType === 1'>
                    <span class='txt1'>{{discountCoupon(item.value,10)}}</span>
                    <span class='txt2'>折</span>
                  </div>
                  <div class='detail'>
                    <div class='detail_title'>【{{item.providerName}}】{{item.title}}</div>
                    <div class='detail_desc'>
                      <span class='txt3' v-if='item.amount == 0'>无门槛</span>
                      <span class='txt3' v-else>消费满{{item.amount}}可用</span>
                      <div v-if='item.isShowBeginDate'>
                        <span class='txt4'>有效期从:{{getCurrentTime(item.rangeBeginTime)}} 至:{{getCurrentTime(item.rangeEndTime)}}</span>
                      </div>
                      <div v-else>
                        <span class='txt4'>有效期至:{{getCurrentTime(item.rangeEndTime)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='coupon_right'>
                  <div>- 已过期 -</div>
                </div>
              </div>
            </div>
            <el-pagination
              @current-change="handleCurrentChangeInvalid"
              :current-page.sync="currentPageInvalid"
              :page-size="limitInvalid"
              layout="prev, pager, next, jumper"
              :total="totalCountInvalid"
              v-if="invalidcouponsList.length"
              style="text-align:center">
            </el-pagination>
          </template>
        </el-container>
      </el-container>
    </div>
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
    <!-- 转赠 -->
    <el-dialog
      id="transfer_dialog"
      :visible.sync="dialogVisible"
      width="400px">
      <img src="../../assets/coupons_transfer.png">
      <div class="title">
        【{{item.providerName}}】{{item.title}}
      </div>
      <div class="tip1">您确定转赠该优惠券？</div>
      <div class="tip2">转赠优惠券您将无法使用该优惠券</div>
      <div class="submit">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm">
          <el-form-item prop="mobile">
            <el-input v-model="dataForm.mobile" placeholder="请输入接受转赠手机号" clearable></el-input>
          </el-form-item>
          <a class="ensure" @click="doTransfer()">确 定</a>
        </el-form>
      </div>
    </el-dialog>
    <!-- 规则 -->
    <rules-detail v-if="rulesDetailVisible" ref="rulesDetail"></rules-detail>
  </div>
</template>

<script>
  import '@/assets/css/index.css'
  import NavLeft from '@/components/NavLeft.vue'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread.vue'
  import Tabbar from '@/components/Tabbar.vue'
  import RulesDetail from '../../components/coupons-rules-detail'
  import axios from 'axios'
  import {getCookie, numberLength, discountCoupon, getCurrentTime} from "../../util/util";
  export default {
    name: "myCoupons",
    data() {
      return {
        p_activeIndex: "9",
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showNavbar: true,
        loading: false,
        selected: "Mine",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_Filled.png")
        ],
        jbImg: {
          'green': 'https://pic.jianyanwang.com/upload/20181126/bc448451fdb04948baa69ccc6ded84ae.png',
          'grey': 'https://pic.jianyanwang.com/upload/20181126/b1b843cee3af44eca9a473b3a5ed9f68.png'
        },
        isValidity: 1,
        dataForm: {
          mobile: ''
        },
        dataRule: {
          mobile: [
            { required: true, pattern: '[^ \x22]+', message: '手机号不能为空' },
            { pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号' }
          ]
        },
        mycouponsList: [],
        totalCount: 0,
        currentPage: 1,
        limit: 9,
        page: 1,
        expiryount: 0,
        dialogVisible: false,
        item: '',
        invalidcouponsList: [],
        totalCountInvalid: 0,
        currentPageInvalid: 1,
        limitInvalid: 9,
        pageInvalid: 1,
        rulesDetailVisible: false,
        providerId: this.$store.state.providerId || localStorage.getItem("providerId") || ''
      }
    },
    components: {
      NavLeft,
      NavHeader,
      NavBread,
      Tabbar,
      RulesDetail
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      numberLength () {
        return function (number) {
          return numberLength(number)
        }
      },
      discountCoupon () {
        return function (number1, number2) {
          return discountCoupon(number1, number2)
        }
      },
      getCurrentTime () {
        return function (time) {
          return getCurrentTime(time)
        }
      }
    },
    mounted() {
      if (getCookie("_token")) {
        this.getMycouponsList(1)
        this.getInvalidcouponsList(1)
        this.getAllcouponsList()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.p_showLoginModal()
      }
    },
    methods: {
      getAllcouponsList() {
        axios.get("/ai/coupon/me", {
          params: {
            platform: 'ZYJY',
            isValidity: 1,
            open: this.providerId ? 0 : 1
          }
        }).then((response) => {
          if (response.data.code === 0) {
            let mycouponsList = response.data.list
            let expiryount = 0
            let curDate = new Date().getTime()
            for (let i = 0; i < mycouponsList.length; i++) {
              mycouponsList[i].rangeEndTime = mycouponsList[i].rangeEndTime.replace(/-/g, '/')
              mycouponsList[i].rangeBeginTime = mycouponsList[i].rangeBeginTime.replace(/-/g, '/')
              let endDate = Date.parse(new Date(mycouponsList[i].rangeEndTime))
              let beginDate = Date.parse(new Date(mycouponsList[i].rangeBeginTime))
              if ((beginDate - curDate)>0) {
                mycouponsList[i].isShowBeginDate = true
              } else {
                mycouponsList[i].isShowBeginDate = false
              }
              if ((endDate - curDate) > 0 && (endDate - curDate) <= 259200000){
                expiryount ++
              }
            }
            this.expiryount = expiryount
          }
        })
      },
      getMycouponsList(flag) {
        if (flag) {
          this.page = flag
        }
        axios.get("/ai/coupon/me/page", {
          params: {
            platform: 'ZYJY',
            isValidity: 1,
            limit: this.limit,
            page: this.page,
            open: this.providerId ? 0 : 1
          }
        }).then((response) => {
          if (response.data.code === 0) {
            let mycouponsList = response.data.page.records
            let curDate = new Date().getTime()
            for (let i = 0; i < mycouponsList.length; i++) {
              mycouponsList[i].rangeEndTime = mycouponsList[i].rangeEndTime.replace(/-/g, '/')
              mycouponsList[i].rangeBeginTime = mycouponsList[i].rangeBeginTime.replace(/-/g, '/')
              let endDate = Date.parse(new Date(mycouponsList[i].rangeEndTime))
              let beginDate = Date.parse(new Date(mycouponsList[i].rangeBeginTime))
              if ((beginDate - curDate)>0) {
                mycouponsList[i].isShowBeginDate = true
              } else {
                mycouponsList[i].isShowBeginDate = false
              }
            }
            this.mycouponsList = mycouponsList
            this.currentPage = response.data.page.current
            this.totalCount = response.data.page.total
          }
        })
      },
      getInvalidcouponsList(flag){
        if (flag) {
          this.pageInvalid = flag
        }
        axios.get("/ai/coupon/me/page", {
          params: {
            platform: 'ZYJY',
            isValidity: 0,
            limit: this.limitInvalid,
            page: this.pageInvalid,
            open: this.providerId ? 0 : 1
          }
        }).then((response) => {
          if (response.data.code === 0) {
            let mycouponsList = response.data.page.records
            let curDate = new Date().getTime()
            for (let i = 0; i < mycouponsList.length; i++) {
              mycouponsList[i].rangeEndTime = mycouponsList[i].rangeEndTime.replace(/-/g, '/')
              mycouponsList[i].rangeBeginTime = mycouponsList[i].rangeBeginTime.replace(/-/g, '/')
              let endDate = Date.parse(new Date(mycouponsList[i].rangeEndTime))
              let beginDate = Date.parse(new Date(mycouponsList[i].rangeBeginTime))
              if ((beginDate - curDate)>0) {
                mycouponsList[i].isShowBeginDate = true
              } else {
                mycouponsList[i].isShowBeginDate = false
              }
            }
            this.invalidcouponsList = mycouponsList
            this.currentPageInvalid = response.data.page.current
            this.totalCountInvalid = response.data.page.total
          }
        })
      },
      // 转赠
      toTransfer(item) {
        this.dialogVisible = true
        this.item = item
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
        })
      },
      doTransfer() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            axios.get("/ai/coupon/gift", {
              params: {
                aiCouponReceiveId: this.item.aiCouponReceiveId,
                mobile: this.dataForm.mobile
              }
            }).then((response)=>{
              if (response.data.code === 0) {
                this.dialogVisible = false
                this.getMycouponsList(1)
                this.$message({
                  type: 'success',
                  message: '转赠成功!'
                })
              }
            })
          }
        })
      },
      // 立即使用
      doUse(item) {
        let rules = JSON.parse(item.rules)
        if (rules.items && rules.itemsType === 0 && rules.items.split(",").length === 1) {
          this.$router.push({
            path: "/detection",
            query: {
              id: rules.items.split(",")[0],
              remark: ''
            }
          })
        } else {
          this.$router.push({
            path: "/goodsList"
          })
        }
        console.log(rules)
      },
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },
      p_closeLoginModal() {
        this.p_loginModalFlag = false
        this.getMycouponsList(1)
        this.getInvalidcouponsList(1)
        this.getAllcouponsList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getMycouponsList()
      },
      handleCurrentChangeInvalid(val) {
        this.pageInvalid = val
        this.getInvalidcouponsList()
      },
      rulesDetailHandle () {
        this.rulesDetailVisible = true
        this.$nextTick(() => {
          this.$refs.rulesDetail.init()
        })
      }
    }
  }
</script>

<style scoped>
  .mshow {
    display: none;
  }
  .list{
    width: 100%;
  }
  .list .coupon,
  .list .coupon_grey{
    width: 30%;
    height: 120px;
    float: left;
    margin: 0 3% 20px 0;
    background :#FFFFFF;
    box-shadow:3px 3px 20px #d8d8d8;
  }
  .list .coupon .coupon_left,
  .list .coupon_grey .coupon_left{
    width: calc(100% - 60px);
    height: 100%;
    float: left;
    position: relative;
  }
  .list .coupon .coupon_left .tip,
  .list .coupon_grey .coupon_left .tip{
    width: 40px;
    height: 40px;
    position: absolute;
  }
  .list .coupon .coupon_left .tip image,
  .list .coupon_grey .coupon_left .tip image{
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    left: 0
  }
  .list .coupon .coupon_left .tip .txt,
  .list .coupon_grey .coupon_left .tip .txt{
    font-size: 12px;
    color: #FFFFFF;
    position: absolute;
    top: 4px;
    left: 6px;
  }
  .list .coupon .coupon_left .price,
  .list .coupon_grey .coupon_left .price,
  .list .coupon .coupon_left .price1,
  .list .coupon_grey .coupon_left .price1,
  .list .coupon .coupon_left .price_discount,
  .list .coupon_grey .coupon_left .price_discount{
    width: 100px;
    height: 100%;
    float: left;
    text-align: center;
    margin: 15px 8px 0 8px;
  }
  .list .coupon .coupon_left .price .txt1,
  .list .coupon_grey .coupon_left .price .txt1,
  .list .coupon .coupon_left .price1 .txt1,
  .list .coupon_grey .coupon_left .price1 .txt1,
  .list .coupon .coupon_left .price_discount .txt2,
  .list .coupon_grey .coupon_left .price_discount .txt2{
    font-size: 12px;
    color: #00C5B0;
  }
  .list .coupon .coupon_left .price .txt2,
  .list .coupon_grey .coupon_left .price .txt2,
  .list .coupon .coupon_left .price1 .txt2,
  .list .coupon_grey .coupon_left .price1 .txt2,
  .list .coupon .coupon_left .price_discount .txt1,
  .list .coupon_grey .coupon_left .price_discount .txt1{
    font-size: 32px;
    color: #00C5B0;
  }
  .list .coupon .coupon_left .detail,
  .list .coupon_grey .coupon_left .detail{
    width: calc(100% - 118px);
    height: 100%;
    float: right;
  }
  .list .coupon .coupon_left .detail .detail_title,
  .list .coupon_grey .coupon_left .detail .detail_title{
    font-size: 12px;
    color: #353535;
    margin: 20px 0 5px 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .list .coupon .coupon_left .detail  .detail_desc,
  .list .coupon_grey .coupon_left .detail  .detail_desc{
    display: block;
    font-size: 12px;
    color: #888888;
  }
  .list .coupon .coupon_right,
  .list .coupon_grey .coupon_right{
    width: 55px;
    height: 100%;
    float: right;
    text-align: center;
    position: relative;
    background: #00C5B0;
    writing-mode: vertical-lr;
    font-size: 14px;
    color: #FFFFFF;
  }
  .list .coupon .coupon_right .coupon_right_btn,
  .list .coupon_grey .coupon_right .coupon_right_btn{
    width: 55px;
    height: 100%;
    line-height: 55px;
    float: left;
    text-align: center;
    position: relative;
    background: none;
    writing-mode: vertical-lr;
    font-size: 14px;
    color: #FFFFFF;
    padding: 0;
    cursor: pointer;
  }
  .list .coupon .coupon_right::before,
  .list .coupon .coupon_right::after,
  .list .coupon_grey .coupon_right::before,
  .list .coupon_grey .coupon_right::after{
    content: '';
    width: 24px;
    height: 24px;
    position: absolute;
    left: -12px;
    background: #f5f5f5;
    border-radius:12px;
  }
  .list .coupon .coupon_right::before,
  .list .coupon_grey .coupon_right::before{
    top:-12px;
    box-shadow: inset 0 -4px 6px #d8d8d8;
  }
  .list .coupon .coupon_right::after,
  .list .coupon_grey .coupon_right::after{
    bottom:-12px;
    box-shadow: inset 0 4px 6px #d8d8d8;
  }
  /*已抢完的优惠券*/
  .list .coupon_grey{
    background: #F5F5F5;
  }
  .list .coupon_grey .coupon_right{
    background: #F5F5F5;
    color: #B2B2B2;
  }
  .list .coupon_grey .coupon_left .price .txt1,
  .list .coupon_grey .coupon_left .price1 .txt1,
  .list .coupon_grey .coupon_left .price_discount .txt1,
  .list .coupon_grey .coupon_left .price .txt2,
  .list .coupon_grey .coupon_left .price1 .txt2,
  .list .coupon_grey .coupon_left .price_discount .txt2,
  .list .coupon_grey .coupon_left .detail .detail_title,
  .list .coupon_grey .coupon_left .detail  .detail_desc,
  .list .coupon_grey .coupon_right .percent{
    color: #B2B2B2;
  }
  .list .coupon_grey .coupon_right .btn{
    background: #E2E2E2;
    color: #B2B2B2;
  }
  .transfer{
    width: 65px;
    margin: 0 auto;
    height: 20px;
    line-height: 20px;
    display: block;
    color: #ffffff;
    font-size: 12px;
    background: #00C5B0;
    border-radius: 8px;
    text-align: center;
  }
  .result-empty{
    width: 260px;
    height: 260px;
    margin: 0 auto;
    padding-top: 50px;
  }
  .result-empty img{
    width: 100%;
    height: 100%;
  }
  .result-empty p{
    text-align: center;
    color: #999999;
  }
  .tab{
    width: 100%;
    padding: 35px 0 0 0;
    border-bottom: 1px solid #cccccc;
    margin-bottom: 25px;
    font-size: 14px;
  }
  .tab ul{
    width: 70%;
    float: left;
  }
  .tab ul li{
    float: left;
    margin-right: 40px;
    padding-bottom: 5px;
    cursor: pointer;
  }
  .tab ul li.isActive{
    border-bottom: 3px solid #00C5B0;
    color: #00C5B0;
  }
  .tab ul li .num{
    color: red;
  }
  .tab .regulation{
    width: 30%;
    float: right;
    text-align: right;
    color: #00C5B0;
    cursor: pointer;
  }
  /* 以下代码与滚动相关 */
  .advert-top{
    position: relative;
    display: flex;
    width: 100%;
    height: 35px;
    background: #fff2f2;
    color: red;
    font-size: 14px;
    align-items: center
  }
  #transfer_dialog >>> .el-dialog__header,
  #transfer_dialog >>> .el-dialog__body{
    padding: 0;
  }
  #transfer_dialog >>> .el-dialog{
    padding-bottom: 30px;
    border-radius: 20px;
  }
  #transfer_dialog img{
    width: 456px;
    height: 278px;
    margin: -85px 0 0 -28px;
  }
  #transfer_dialog .title{
    text-align: center;
    font-size: 20px;
    color: #fa647b;
    margin: -75px 0 35px 0;
  }
  #transfer_dialog .tip1{
    font-size: 19px;
    color: #526473;
    text-align: center;
    margin-bottom: 10px;
  }
  #transfer_dialog .tip2{
    font-size: 16px;
    color: #526473;
    text-align: center;
    margin-bottom: 30px;
  }
  #transfer_dialog >>> .el-input__inner{
    border: none;
    height: 48px;
    line-height: 48px;
    background-color: #e8eaf2;
    border-radius: 20px;
  }
  .submit{
    width: 90%;
    margin: 0 auto;
  }
  .submit .ensure{
    display: inline-block;
    width: 100%;
    background-color: #00C5B0;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    border-radius: 20px;
    line-height: 48px;
  }
  #transfer_dialog >>> .el-input__inner::-webkit-input-placeholder {
    color: #888888;
    font-size: 14px;
    text-align: center;
  }
  #transfer_dialog >>> .el-input__inner:-moz-placeholder {
    color: #888888;
    font-size: 14px;
    text-align: center;
  }
  #transfer_dialog >>> .el-input__inner:-ms-input-placeholder {
    color: #888888;
    font-size: 14px;
    text-align: center;
  }
  #transfer_dialog >>> .el-dialog__headerbtn{
    top: 0;
  }
  @media only screen and (max-width: 1600px) {
    .list .coupon,
    .list .coupon_grey{
      width: 46%;
    }
  }
  @media only screen and (max-width: 767px) {
    /deep/ .container {
      width: 95%;
    }
    /deep/  .el-container {
      margin-left: 0 !important;
      margin-bottom: 50px;
    }
    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0 -10px;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .mshow{
      display: inline-block;
    }
    .mhide{
      display: none;
    }
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel{
      display: none!important;
    }
    .list .coupon,
    .list .coupon_grey{
      width: 100%;
    }
    .tab{
      font-size: 12px;
    }
    #transfer_dialog >>> .el-dialog{
      width: 300px !important;
    }
    #transfer_dialog img{
      width: 342px;
      height: 218px;
      margin: -68px 0 0 -21px;
    }
    #transfer_dialog .title{
      font-size: 18px;
      margin: -59px 0 35px 0;
    }
    #transfer_dialog .tip1{
      font-size: 16px;
    }
    #transfer_dialog .tip2{
      font-size: 14px;
    }
    #transfer_dialog >>> .el-input__inner{
      height: 38px;
      line-height: 38px;
    }
    .submit .ensure{
      line-height: 38px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/MyCoupons.vue